import axios from 'axios'
// create an axios instance
const service = axios.create({
  // baseURL: 'http://www.zhaohui.com/api',
  baseURL:  process.env.NODE_ENV === 'production' ? '/api' : 'http://www.zhaohui.com/api', // url = base url + request url
  // timeout: 10000, // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(

  response => {
    const res = response.data
    return res
  },
  error => {
    console.log('err' + error) // for debug

    return Promise.reject(error)
  }
)

export default service
